/**
 * @class ScrollIntoView
 * @extends HTMLElement
 */
class ScrollIntoView extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #resolveTarget(trigger) {
    const selector = this.getAttribute('target') || (trigger.hash ? `#${trigger.hash.slice(1)}` : null);
    return selector ? document.querySelector(selector) : null;
  }

  #onClick = (event) => {
    const trigger = event.target.closest('a[href^="#"]');
    if (!trigger) return;

    const target = this.#resolveTarget(trigger);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    target
      .querySelector('input, select, textarea, button, a[href], [tabindex]:not([tabindex="-1"])')
      ?.focus({ preventScroll: true });
  };
}

if (!customElements.get('scroll-into-view')) {
  customElements.define('scroll-into-view', ScrollIntoView);
}
